// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2uRPD","search":"Settings_search__3Aq4b","filter":"Settings_filter__3GUPl"};